//import './../Administracion.css'
import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import TipoNomina from './tipoNomina';

import { Mensaje, MensajeSiNo } from '../../../mensajes2';
import { Dimmer } from '../../../spinner';
import useTable from '../../../useTable';
import { Toasts } from '../../../toasts';

import { Input } from '../../../../ui/inputs/Input';

import { PrimaryButton } from '../../../../ui/buttons/Button';

const TablaTipoNomina = (props) => {
    var op = require('../../../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const headCells = [
        { id: 'codigo', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' },
        { id: 'descripcion', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' },
        { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
    ]
    const colores = [
        '#17a2b8',
        '#ffae00',
        '#dc3545',
        '#BDB76B',
        '#7B68EE',
        '#4B0082',
        '#00ffff',
        '#0080ff',
        '#0000ff',
        '#8000ff',
        '#ff00ff',
        '#ff0080',
    ];
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const txtBuscador = useRef();
    const [mostrar2, setMostrar2] = useState(false);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(1);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const permiso = JSON.parse(localStorage.getItem('accbanco'))
    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: '',
        titulo: ''
    })
    const [nomina, setNomina] = useState();
    const [periodos, setPeriodos] = useState();

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                if (target.value === "")
                    return items;
                else
                    return items.filter(x => {
                        if ((x.codnomi !== null ? x.codnomi.includes(target.value) : '')
                            || (x.titnomi !== null ? x.titnomi.toLowerCase().includes(target.value.toLowerCase()) : '')
                        ) {
                            return x;
                        }
                    });
            }
        })

    }

    const seleccionarRegistros = () => {
        let campos =
            "*";
        let nomtab = "tiponomina";
        let orden = "codnomi";
        const municipioss = [];
        const results = [];
        const element = [];

        let endpoint =
            op.conexion +
            `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        setActivate(true);
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    setRecords(response.data);
                }
                setActivate(false);
            })
            .catch(function (error) {
                setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
                setActivate(false);
            });
    };
    const cerrarToast = () => {
        setToast({
            ...toast,
            mostrar: false
        })
    }
    const seleccionarTipoNomina = (id) => {
        let campos = "*"
        let nomtab = "tiponomina";
        let nomid = "codnomi";

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            if (response.status === 200) {
                if (response.data.codnomi !== '') {
                    setNomina(response.data)
                    seleccionarPeriodo(response.data.codnomi);
                    //setMostrar2(true)
                    //setActivate(false);
                }
            }
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const seleccionarPeriodo = (codnomi) => {
        setActivate(true);
        
        let campos = "*";
        let nomtab = "periodos";
        let condi = "codnomi = '" + codnomi + "'";
        let orden = "numper";
        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            if (response.status == 200) {
                if (response.data.length > 0) {
                    setPeriodos(response.data);
                    setMostrar2(true);
                } 
            }
            setActivate(false)
        }).catch(function (error) {
            setMensaje({
                mostrar: true,
                titulo: "ERROR",
                texto: error.response.data.message,
                icono: "error",
            });
            setActivate(false)
        })
    }

    const cerrarModal = () => {
        setMostrar2(false)
    }
    const gestionarTipoNomina = (op, id, per) => (e) => {
        e.preventDefault();
        if (per.toString() === '1') {
            setOperacion(op)
            if (op === 1) {
                setMostrar2(true)
            } else {
                if (op === 3 && id === JSON.parse(localStorage.getItem('codigonomina')).trim()){
                    setMensaje({
                        mostrar: true,
                        titulo: "Información",
                        texto:
                            "La Nomina no puede ser eliminada está siendo utilizada actualmente.",
                        icono: "informacion",
                    });
                } else {
                    seleccionarTipoNomina(id);
                }
                
            }
        } else {
            setToast({
                mostrar: true,
                mensaje: op === 1 ? 'No posee permiso para Registrar' : op === 2 ? 'No posee permiso para Editar' : op === 3 ? 'No posee permiso para Eliminar' : 'No posee permiso para Consultar',
                titulo: 'Alerta.'
            })
        }
    }

    const handleCloseSi = () => {
        setActivate(false);
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })
    };

    useEffect(() => {
        seleccionarRegistros();
        setActivate(true);
    }, []);

    const cerrar = () => {
        props.setTabla(0)
    }
    return (
        <section className='col-8 m-0 p-0'>
            <header className='col-12 m-0 px-4 py-2 rounded-top d-flex align-items-center justify-content-between azulGradiant text-light'>
                <h3 className='m-0'>
                    Getionar Tipos de Nomnas
                </h3>
                <a type='button' onClick={cerrar}>
                    salir<i className="fas fa-times ms-2"></i>
                </a>
            </header>
            <form onSubmit={(e) => { e.preventDefault() }} className="d-flex justify-content-between p-2">
                <div className='col-4 m-0 p-0'>
                    <Input type="text"
                        ref={txtBuscador}
                        onChange={handleSearch}
                        placeholder="Buscar" />
                </div>
                <PrimaryButton icon='fa-plus m-0'
                    disabled={permiso.toString().substring(1, 2) !== '1'}
                    onClick={gestionarTipoNomina(1, '', permiso.toString().substring(1, 2))}
                    title='Agregar Contribuyente'
                >
                </PrimaryButton>
            </form>
            <div className="">
                <TblContainer>
                    <TblHead />
                    <tbody>
                        {
                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                <tr key={index} style={{ padding: "0" }}>
                                    <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{item.codnomi}</td>
                                    <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '300px' }}>{item.titnomi}</td>

                                    <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>
                                        <button onClick={gestionarTipoNomina(4, item.codnomi, permiso.toString().substring(0, 1))} className={permiso.toString().substring(0, 1) === '1' ? 'btn btn-sm btn-info rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}><i className="fas fa-eye"></i> </button>
                                        <a> &nbsp; </a>
                                        <button onClick={gestionarTipoNomina(2, item.codnomi, permiso.toString().substring(2, 3))} className={permiso.toString().substring(2, 3) === '1' ? 'btn btn-sm btn-warning rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}><i className="fa fa-edit"></i> </button>
                                        <a> &nbsp; </a>
                                        <button onClick={gestionarTipoNomina(3, item.codnomi, permiso.toString().substring(3, 4))} className={permiso.toString().substring(3, 4) === '1' ? 'btn btn-sm btn-danger rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}><i className="fa fa-trash-alt"></i> </button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </TblContainer>
                <TblPagination />
            </div>
            <TipoNomina
                show={mostrar2}
                onHideCancela={cerrarModal}
                operacion={operacion}
                nomina={nomina}
                periodos={periodos}
                onHideRenderizar={seleccionarRegistros} />
            <Dimmer active={activate} inverted></Dimmer>
            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
            <Toasts
                show={toast.mostrar}
                titulo={toast.titulo}
                mensaje={toast.mensaje}
                onHideCancela={cerrarToast} />
        </section>
    );
}
export default TablaTipoNomina;